<template>
  <div class="w-full flex flex-wrap">

    <div class="md:w-2/3 w-full">

      <div class="mx-auto md:mt-16 w-full flex justify-center">
        <AppLogo class="rounded-2xl h-36 w-36"  />
      </div>
      <Head :title="__('Login to Onshow')" />

      <form
        @submit.prevent="attempt"
        class="p-8 max-w-[30rem] mx-auto"
      >
        <h2 class="text-2xl text-center font-normal mb-2">
          {{ __('Login to Onshow') }}
        </h2>

        <div class="mb-6">
          <label class="block mb-2" for="phone_number">
            {{ __('Phone Number') }}
          </label>
          <input
            v-model="form.phone_number"
            class="form-control form-input form-input-bordered w-full"
            :class="{ 'form-input-border-error': form.errors.has('phone_number') }"
            id="phone_number"
            type="text"
            name="phone_number"
            dir="ltr"
            placeholder="09120000000"
            autofocus=""
            required
          />

          <HelpText class="mt-2 text-red-500" v-if="form.errors.has('phone_number')">
            {{ form.errors.first('phone_number') }}
          </HelpText>
        </div>

        <div class="mb-6">
          <label class="block mb-2" for="password">{{ __('Password') }}</label>
          <div class="relative">
            <input
              v-model="form.password"
              class="form-control form-input form-input-bordered w-full pr-10"
              :class="{ 'form-input-border-error': form.errors.has('password') }"
              id="password"
              dir="ltr"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              placeholder="رمز عبور خود را وارد کنید"
              required
            />
            <button
              type="button"
              @click="showPassword = !showPassword"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <HeroiconsSolidEye v-if="!showPassword" class="w-5 h-5" />
              <HeroiconsSolidEyeOff v-else class="w-5 h-5" />
            </button>
          </div>

          <HelpText class="mt-2 text-red-500" v-if="form.errors.has('password')">
            {{ form.errors.first('password') }}
          </HelpText>
        </div>

        <div class="flex mb-6 items-center justify-between">
          <Checkbox
            @change="() => (form.remember = !form.remember)"
            :model-value="form.remember"
            dusk="remember-button"
            :label="__('Remember me')"
          />

          <div
            v-if="supportsPasswordReset || forgotPasswordPath !== false"
            class="ml-auto"
          >
            <Link
              v-if="forgotPasswordPath === false"
              :href="$url('/password/reset')"
              class="text-primary-500 font-bold underline hover:text-primary-600"
              v-text="__('Forgot your password?')"
            />
            <a
              v-else
              :href="forgotPasswordPath"
              class="text-primary-500 font-bold underline hover:text-primary-600"
              v-text="__('Forgot your password?')"
            />
          </div>
        </div>

        <Button
          class="w-full flex justify-center rounded-lg bg-primary-500 hover:bg-primary-600 text-white"
          type="submit"
          :loading="form.processing"
        >
          <span>
            {{ __('Login') }}
          </span>
        </Button>

      </form>
    </div>

    <div class="md:w-1/3 md:block hidden h-screen">
      <img src="/images/login.png" alt="Login Image" class="w-full h-screen object-contain">
    </div>



  </div>
</template>

<script>
import Auth from '@/layouts/Auth'
import { Button, Checkbox } from 'laravel-nova-ui'
import { Link } from '@inertiajs/inertia-vue3'
import HeroiconsSolidEye from '@/components/Heroicons/solid/HeroiconsSolidEye'
import HeroiconsSolidEyeOff from '@/components/Heroicons/solid/HeroiconsSolidEyeOff'

export default {
  name: 'LoginPage',

  layout: Auth,

  components: {
    Checkbox,
    Button,
    Link,
    HeroiconsSolidEye,
    HeroiconsSolidEyeOff,
  },

  data: () => ({
    showPassword: false,
    form: Nova.form({
      phone_number: '',
      password: '',
      remember: false,
    }),
  }),

  mounted() {
    // نمایش flash messages از session
    if (this.$page.props.flash?.error) {
      Nova.error(this.$page.props.flash.error)
    }
    if (this.$page.props.flash?.success) {
      Nova.success(this.$page.props.flash.success)
    }
  },

  methods: {
    async attempt() {
      try {
        const { redirect } = await this.form.post(Nova.url('/login'))

        let path = { url: Nova.url('/'), remote: true }

        if (redirect !== undefined && redirect !== null) {
          path = { url: redirect, remote: true }
        }

        Nova.visit(path)
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },

    loginWithGoogle() {
      // Redirect to Google OAuth endpoint
      window.location.href = '/auth/google'
    },
  },

  computed: {
    supportsPasswordReset() {
      return Nova.config('withPasswordReset')
    },

    forgotPasswordPath() {
      return Nova.config('forgotPasswordPath')
    },
  },
}
</script>
